import SlotTimes from "./slot-times";
export default SlotTimes;